import type { Selection } from "../types";

export type RowMultiSelection = {
  selectedRowIds: string[];
  primaryRowId: string | null;
  anchorRowId: string | null;
};

export function emptyRowMultiSelection(): RowMultiSelection {
  return {
    selectedRowIds: [],
    primaryRowId: null,
    anchorRowId: null,
  };
}

export function rowMultiSelectionFromRowId(rowId: string): RowMultiSelection {
  return {
    selectedRowIds: [rowId],
    primaryRowId: rowId,
    anchorRowId: rowId,
  };
}

export function deriveRowMultiSelectionFromSelection(
  selection: Selection,
): RowMultiSelection {
  if (selection.kind === "row") {
    return rowMultiSelectionFromRowId(selection.rowId);
  }

  return emptyRowMultiSelection();
}

export function getPrimaryRowId(
  rowSelection: Pick<RowMultiSelection, "primaryRowId" | "selectedRowIds">,
): string | null {
  if (
    rowSelection.primaryRowId !== null &&
    rowSelection.selectedRowIds.includes(rowSelection.primaryRowId)
  ) {
    return rowSelection.primaryRowId;
  }

  return rowSelection.selectedRowIds[0] ?? null;
}
